// NAME-SPACE of modules
import { ModulesMap } from '../modulesMaps'

// ENDPOINTS MODULES
import auth from './authEndpointConfig'
import cacheEndpointConfig from './cacheEndpointConfig'
import user from './userEndpointConfig'
import company from './companyEndpointConfig'
import presets from './presetsEndpointConfig'

import mapsEndpointConfig from './mapsEndpointConfig'

export default {
	[ModulesMap.CACHE]: cacheEndpointConfig,
	[ModulesMap.USER]: user,
	[ModulesMap.COMPANY]: company,
	[ModulesMap.AUTH]: auth,
	[ModulesMap.PRESETS]: presets,

	[ModulesMap.MAPS]: mapsEndpointConfig,
}
